import { Alert, Button, Card, Menu, Dropdown, Tooltip, DatePicker, ConfigProvider, Form, Col, Row, Select } from 'antd';
import { DownOutlined, SortAscendingOutlined, SortDescendingOutlined, CheckOutlined, SearchOutlined, FileImageOutlined, FilePdfOutlined, CloudUploadOutlined, EyeOutlined } from '@ant-design/icons';
import { useEffect, useState } from 'react';
import ReactJson from 'react-json-view';
import Navigation from './Navigation'
import { Input } from 'antd';
import { Label, Segment } from 'semantic-ui-react';
import { Filter, FilterType, UploadsStatus } from '../pages/Interfaces';
import React from 'react'
import moment from 'moment'
import 'moment/locale/sk';
import sk_SK from 'antd/lib/locale/sk_SK';
import { Icon } from 'semantic-ui-react';
import Auth from '@aws-amplify/auth';
import { Option } from 'antd/lib/mentions';
import TextArea from 'antd/lib/input/TextArea';
import { setContext } from '@sentry/react';
import OrderItem from './OrderList.item';
import axios from 'axios';
import { COMPANY_LOOKUP_HOST } from '../../../constants';
import { saveAs } from 'file-saver';

export function OrderList({
  isLoading,
  showCreate,
  documents,
  refresh
}: {
  documents: object[];
  showCreate?: boolean;
  isLoading?: boolean;
  refresh: () => void;
}) {
  const [token, setToken] = useState('')
  useEffect(() => {
    Auth.currentSession().then(session => {
      const jwtToken = session.getAccessToken().getJwtToken()
      setToken(jwtToken)
    })
  })
  if (isLoading) {
    return <Alert message="Načítavam" type="info" />;
  }
  if (!isLoading && !showCreate && documents.length > 0) {
    return (
      <>
        {documents.map((item: any) => (
          <OrderItem token={token} data={item} key={`docitem-${item.id || item.name}`} refresh={refresh} />
        ))}
      </>
    );
  }
  if (!isLoading && !showCreate && (!documents || documents.length === 0)) {
    return <Alert message="Neboli nájdené žiadne objednávky." type="warning" />;
  }

  return null;
}

export function OrderListHeader({
  sortBy,
  sortDir,
  setSortBy,
  setFilters,
  pageChange,
  filters,
  selectedFilters
}: {
  sortBy: string,
  sortDir: string,
  setSortBy: (value: string) => void,
  setFilters: (filter: string) => void,
  pageChange: (value: number, size?: number) => void,
  filters: Filter[],
  selectedFilters: string[]
}) {
  const [sortMenuVisible, setSortMenuVisible] = useState(false)
  const [filterMenuVisible, setFilterMenuVisible] = useState(false)
  const [, updateState] = React.useState({});
  const forceUpdate = React.useCallback(() => updateState({}), []);
  const sortMenu = (
    <Menu>
      <Menu.Item onClick={() => setSortBy("created_at")}>
        Vytvorené {sortBy === 'created_at' && (sortDir === "ASC" ? <SortAscendingOutlined /> : <SortDescendingOutlined />)}
      </Menu.Item>
      <Menu.Item onClick={() => setSortBy("updated_at")}>
        Upravené {sortBy === 'updated_at' && (sortDir === "ASC" ? <SortAscendingOutlined /> : <SortDescendingOutlined />)}
      </Menu.Item>
      <Menu.Item onClick={() => setSortBy("formData.companyName")}>
        Názov spoločnosti {sortBy === 'formData.spolocnost' && (sortDir === "ASC" ? <SortAscendingOutlined /> : <SortDescendingOutlined />)}
      </Menu.Item>
    </Menu>
  )

  function filterMenu() {
    return (
      <Menu>

        {filters.map((filter => {
          return (
            <Menu.Item key={filter.name} onClick={() => { setFilters(filter.name); forceUpdate() }}>
              {filter.translation} {selectedFilters.indexOf(filter.name) !== -1 ? <CheckOutlined /> : ""}
            </Menu.Item>
          )
        }))}
      </Menu>)
  }

  const setFilterValue = (filter: Filter, e: any) => {
    if (filter.type === FilterType.DATE_TIME) {
      if (e === null) {
        filter.value = ""
      } else {
        filter.value = e
      }
    } else if (filter.type === FilterType.STRING) {
      filter.value = e.target.value
    } else {
      filter.value = e
    }
    forceUpdate()
  }

  const handleTriggerExport = async () => {
    await axios.get(`${COMPANY_LOOKUP_HOST}/order/export-orders`, {
      responseType: 'blob'
    },
    ).then((res) => {
      saveAs(res.data, "export.csv");
    });
  };

  return (
    <>
      <Navigation />
      <Card style={{ background: '#f0f0f0', padding: "4rem 15% 0" }}>
        <div>
          <div style={{ display: 'flex' }}>
            <h3
              style={{
                width: '100%',
                justifyContent: 'space-between',
                alignItems: 'center',
                fontSize: '1.375rem',
                margin: 0
              }}>
              Objednávky{' '}
            </h3>
            <div>
              <Dropdown
                overlay={sortMenu}
                onVisibleChange={setSortMenuVisible}
                visible={sortMenuVisible}
              >
                <a style={{ display: 'flex', marginRight: 40 }} className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                  <Icon name="sort" size='large' />
                  Zoradiť
                </a>
              </Dropdown>
            </div>
            <div >
              <Dropdown
                overlay={filterMenu}
                onVisibleChange={setFilterMenuVisible}
                visible={filterMenuVisible}
                forceRender
              >
                <a style={{ display: 'flex' }} className="ant-dropdown-link" onClick={e => e.preventDefault()}>
                  <Icon name="filter" size='large' />
                  Filtre
                </a>
              </Dropdown>
            </div>
            <div>
              <Button onClick={handleTriggerExport} style={{ display: 'flex', marginLeft: 20 }} >Export</Button>
            </div>
          </div>
          <div style={{ marginTop: "5px" }}>
            <Input.Group compact>
              {filters.map((filter, index) => {
                return (
                  selectedFilters.indexOf(filter.name) !== -1 && (
                    filter.type === FilterType.DATE_TIME ?
                      <ConfigProvider locale={sk_SK}>
                        <DatePicker
                          format="HH:mm DD.MM.YYYY"
                          style={{ minWidth: "150px", width: '15%', marginRight: "5px" }}
                          onChange={(e) => {
                            setFilterValue(filter, e)
                            pageChange(1)
                          }}
                          showTime={{ defaultValue: moment(filter.value !== "" ? filter.value : undefined) }}
                        />
                      </ConfigProvider>
                      :
                      filter.type === FilterType.STRING ?
                        <Input onChange={(e) => setFilterValue(filter, e)} style={{ minWidth: "150px", width: '15%', marginRight: "5px" }} value={filter.value} placeholder={filter.translation} onKeyDown={
                          (event) => {
                            if (event.key === 'Enter') {
                              pageChange(1)
                            }
                          }
                        } />
                        :
                        <Select onChange={(e) => {
                          setFilterValue(filter, e)
                          pageChange(1)
                        }} style={{ minWidth: "150px", width: '15%', marginRight: "5px" }} value={filter.value} placeholder={filter.translation} >
                          {filter.values?.map(value => {
                            return (
                              <Option value={value.value} key={value.value}>
                                {value.name}
                              </Option>
                            )
                          })}
                        </Select>
                  )
                )
              })}
              {selectedFilters.length > 0 &&
                <Tooltip title="search">
                  <Button onClick={() => pageChange(1)} shape="circle" icon={<SearchOutlined />} />
                </Tooltip>
              }
            </Input.Group>
          </div>
        </div>
      </Card>
    </>
  );
}

